module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "deletefoldermodal",
    attrs: {
      "id": "delete-folder-modal",
      "title": "Are you sure you want to delete this folder?",
      "name": "delete-folder-modal",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Delete",
      "close-title": "Cancel",
      "hide-header-close": ""
    },
    on: {
      "ok": _vm.handleOk
    }
  }, [_vm._v("\n  This will also delete all folders and requirements inside this folder\n  "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Deleting\n  ")], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0747a882"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/DeleteFolderModal.vue
// module id = 994
// module chunks = 1